import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector, change } from 'redux-form';
import Dialog from 'material-ui/Dialog';
import { renderAutoCompleteScheduling, renderCheckBox, renderTextField } from '../../../../../components/reduxFields';
import { CancelButton, SubmitButtonModal, SubmitButtonModalDisabled } from '../../../../../components/buttons';
import { saveDocumentType, getDocumentTypeById } from '../actions';
import validate from '../validate';
import { checkFieldExistence, clearFieldErrorArray } from '../../../../AppConfig/actions';
import { MODULE } from '../constants/ApiConstants';
import { displayCustomError } from '../../../../../actions/utilAction';
import SmallLoader from '../../../../../img/small-loader.gif';

class MasterDocumentTypesModal extends Component {

  constructor(props) {
    super(props);
    this.state = {
      open: true,
      documentTypeId: props.documentTypeId,
      masterDocumentTypesStaffUserRoles: [],
      masterDocumentTypesStaffUserPayers: [],
      isBillableDisabled: false,
      displayBillableAndNonBillableCheckboxes: false,
    };
    this.handleNewMultiUserRequest = this.handleNewMultiUserRequest.bind(this);
    this.handleNewMultiInsuranceRequest = this.handleNewMultiInsuranceRequest.bind(this);
    this.checkIsRequiredDocument = this.checkIsRequiredDocument.bind(this);
  }

  handleOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    if (this.state.open) {
      this.props.clearFieldErrorArray();
      this.setState({ open: false });
      this.props.closeDialog();
    }
  };
  componentWillReceiveProps(nextProps) {
    let self = this;
    document.onkeydown = function(evt) {
      evt = evt || window.event;
      if (evt.keyCode === 27) {
        self.handleClose();
      }
    };

    if (nextProps.masterDocumentTypeDetail && nextProps.masterDocumentTypeDetail !== this.props.masterDocumentTypeDetail) {
      let masterDocumentTypeData = nextProps.masterDocumentTypeDetail.data;      
      let masterDocumentTypesStaffUserRoles = masterDocumentTypeData.masterDocumentTypesStaffUserRoles || [];      
      let masterDocumentTypesStaffPayers = masterDocumentTypeData.masterDocumentTypesStaffPayers || [];   
      
      let isBillableDisabled = false;
      if(masterDocumentTypesStaffPayers && masterDocumentTypesStaffPayers.length > 0) {
        isBillableDisabled = true;
      }
      else{
        isBillableDisabled = false;
      }

      let displayBillableAndNonBillableCheckboxes = false;
      if(masterDocumentTypeData.isRequiredDocument){        
        displayBillableAndNonBillableCheckboxes = true;
      } else  {
        displayBillableAndNonBillableCheckboxes = false;      
      }
      
      this.setState({ 
        masterDocumentTypesStaffUserRoles: masterDocumentTypesStaffUserRoles
        , masterDocumentTypesStaffPayers: masterDocumentTypesStaffPayers
        , displayBillableAndNonBillableCheckboxes: displayBillableAndNonBillableCheckboxes
        , isBillableDisabled: isBillableDisabled
      });
    }

  }
  checkFieldDataExistence = (input, value, labelName) => {
    if (value.length > 0) {

      let postData = {
        'labelName': labelName,
        'tableName': `${MODULE}_${input.target.name}`.toUpperCase(),
        'value': value,
        'colmnName': input.target.name.toUpperCase(),
        'id': (this.props.initialValues && this.props.initialValues.id) ? this.props.initialValues.id : 0,
      };
      // console.log('input.postData...........',postData)
      this.props.checkFieldExistence(postData);
    }
  };
  componentWillMount() {
    if (this.props.documentTypeId) {
      this.props.getDocumentTypeById(this.props.documentTypeId);
    }
  }
  onSubmitHandler(formData) {
    if ((this.props.fieldError && this.props.fieldError.length) || (this.props.fieldErrorLoading)) { // Avoid Submit if field error checking
      return null;
    }
    formData.type = formData.type.trim();
    formData.isActive = formData.isActive ? true : false;
    formData.isRequiredDocument = formData.isRequiredDocument ? true : false;    
    formData.billable = formData.billable ? true : false;    
    formData.nonBillable = formData.nonBillable ? true : false;    
    formData.value = undefined;

    let masterDocumentTypesStaffUserRoles = [];
    if (formData.userRoles) {
      masterDocumentTypesStaffUserRoles = (this.state.masterDocumentTypesStaffUserRoles || []).map((Obj) => {
        return { ...Obj, isDeleted: true };
      });

      (formData.userRoles || []).forEach((roleId) => {
        // update case for userRoles ------
        let userRoles = masterDocumentTypesStaffUserRoles.find((Obj) => Obj.roleId === roleId && Obj.isDeleted);
        if (userRoles) {
          let index = masterDocumentTypesStaffUserRoles.indexOf(userRoles);
          masterDocumentTypesStaffUserRoles[index] = {
            ...userRoles,
            'isDeleted': false,
          };
        } else {
          masterDocumentTypesStaffUserRoles.push({
            'id': 0,
            'documentTypeId': this.props.documentTypeId || 0,
            'roleId': roleId,
            'isDeleted': false,
          });
        }
      });
   
      masterDocumentTypesStaffUserRoles = masterDocumentTypesStaffUserRoles;//.filter((obj) => obj.isDeleted === false);
      //console.log('masterDocumentTypesStaffUserRoles........',masterDocumentTypesStaffUserRoles);
    }

    let masterDocumentTypesStaffPayers = [];
    if (formData.payers) {
      masterDocumentTypesStaffPayers = (this.state.masterDocumentTypesStaffPayers || []).map((Obj) => {
        return { ...Obj, isDeleted: true };
      });

      (formData.payers || []).forEach((payerId) => {
        // update case for payers ------
        let payers = masterDocumentTypesStaffPayers.find((Obj) => Obj.payerId === payerId && Obj.isDeleted);
        if (payers) {
          let index = masterDocumentTypesStaffPayers.indexOf(payers);
          masterDocumentTypesStaffPayers[index] = {
            ...payers,
            'isDeleted': false,
          };
        } else {
          masterDocumentTypesStaffPayers.push({
            'id': 0,
            'documentTypeId': this.props.documentTypeId || 0,
            'payerId': payerId,
            'isDeleted': false,
          });
        }
      });
   
      masterDocumentTypesStaffPayers = masterDocumentTypesStaffPayers;//.filter((obj) => obj.isDeleted === false);
      //console.log('masterDocumentTypesStaffPayers........',masterDocumentTypesStaffPayers);
    }

    let postData = {
      ...formData,
      'id': this.props.documentTypeId || 0,   
      'masterDocumentTypesStaffUserRoles': masterDocumentTypesStaffUserRoles,
      'masterDocumentTypesStaffPayers': masterDocumentTypesStaffPayers,
    };

    // console.log('formData.........inner.......',formData)
    this.props.clearFieldErrorArray();
    this.props.saveDocumentType(postData);
    this.setState({ open: false });
    this.props.closeDialog();
  }

  checkIsRequiredDocument = (e, name) => {
    if (name === 'isRequiredDocument' && e.target.checked) {     
      this.setState({ displayBillableAndNonBillableCheckboxes: true });      
    } else  {
      this.setState({ displayBillableAndNonBillableCheckboxes: false });      
    }
  }

  handleNewMultiUserRequest(input, value) {    
    input.onChange(value);        
    if (value.length > 0) {         
      this.setState({ displayBillableAndNonBillableCheckboxes: true },()=>{        
        this.props.dispatch(change('MasterDocumentTypesModalForm', 'isRequiredDocument', true));        
      });   
    }
    
  } 

  handleNewMultiInsuranceRequest(input, value) {    
    input.onChange(value);        
    if (value.length > 0) {         
      this.setState({ isBillableDisabled: true, displayBillableAndNonBillableCheckboxes: true },()=>{        
        this.props.dispatch(change('MasterDocumentTypesModalForm', 'isRequiredDocument', true));
        this.props.dispatch(change('MasterDocumentTypesModalForm', 'billable', true));
      });      
    }
    else {
      this.setState({ isBillableDisabled: false },()=>{
        this.props.dispatch(change('MasterDocumentTypesModalForm', 'billable', false));
      });
    }
  } 

  renderLoading() {
    return (
      <div>
        {this.props.loading ?
          <div className="full_loader top0">
            <div className="small-loader">
              <img src={SmallLoader} alt="" />
            </div>
          </div>
          : null}
      </div>
    );
  }
  render() {
    const { handleSubmit } = this.props;
    let submitButton = this.props.loading ?
      <SubmitButtonModalDisabled label="Saving" /> :
      this.props.fieldErrorLoading ? <SubmitButtonModalDisabled label="Save" /> : <SubmitButtonModal label="Save" onSubmit={handleSubmit(this.onSubmitHandler.bind(this))} />;
    const actions = [
      <CancelButton className="mr-15" onTouchTap={this.handleClose} />,
      submitButton,
    ];
    return (
      <Dialog className="custom_modal"
        title={this.props.documentTypeId ? 'Edit Staff Document Type' : 'Add Staff Document Type'}
        modal={false}
        open={this.state.open}
        actions={actions}
        autoScrollBodyContent={true}>

        <div className="row">
          <div className="col-sm-12">
            <form className="readmin-form custom_form" onSubmit={handleSubmit(this.onSubmitHandler.bind(this))}>
              <div className="row">
                <div className="col-sm-12 require">
                  <Field
                    autoFocus={true}
                    name="type"
                    type="text"
                    onBlur={(input, value) => this.checkFieldDataExistence(input, value, 'Document type')}
                    customError={displayCustomError('TYPE', this.props.fieldError)}
                    maxLength="50"
                    label="Document Type"
                    component={renderTextField} />
                </div>
              </div>              
              <div className='row'>        
                <div className="col-sm-12 mt-40">
                  {/* <small className="greyfont font12">Only allow the following roles to view this appointment type: </small> */}
                  <Field
                    name="userRoles"
                    label="User Roles"
                    handleNewRequest={this.handleNewMultiUserRequest}
                    options={this.props.userRoleList}
                    component={renderAutoCompleteScheduling}
                    fullWidth={true}
                  />
                  <small className="redfont font12">If "required document" is checked and no roles are selected then document will be required across all roles. </small>
                </div>
              </div>               
              <div className='row'>    
                <div className="col-sm-12 mt-40">
                  {/* <small className="greyfont font12">Only allow the following roles to view this appointment type: </small> */}
                  <Field
                    name="payers"
                    label="Payers"
                    handleNewRequest={this.handleNewMultiInsuranceRequest}
                    options={this.props.insuranceCompaniesList}
                    component={renderAutoCompleteScheduling}
                    fullWidth={true}
                  />
                  <small className="redfont font12">If "required document" is checked and no payers are selected then document will be required across all payers. </small>
                </div>
              </div> 
              <div className="row">
                <div className="col-sm-6">
                  <Field className="mt20 mb0"
                    name="isActive"
                    label="Active"
                    component={renderCheckBox}
                  />
                </div>
                <div className="col-sm-6">
                  <Field className="mt20 mb0"
                    name="isRequiredDocument"
                    label="Required Document"
                    component={renderCheckBox}
                    onChange={(e) => this.checkIsRequiredDocument(e, 'isRequiredDocument')}
                  />
                  <small className="redfont font12">Users will not be able to schedule if they do not have an active document on file.</small>
                </div>
              </div>
              {this.state.displayBillableAndNonBillableCheckboxes ? 
              <div className="row">
                <div className="col-sm-6">
                  <Field className="mt20 mb0"
                    name="billable"
                    label="Billable"
                    disabled = {this.state.isBillableDisabled}
                    component={renderCheckBox}
                  />
                </div>
                <div className="col-sm-6">
                  <Field className="mt20 mb0"
                    name="nonBillable"
                    label="Non Billable"
                    component={renderCheckBox}
                  />
                </div>
              </div> : null}

              {/* <div className="row">
                <div className="col-sm-12 pt20 btn_rt">
                  <FlatButton className="grey_btn"
                    label="Cancel"
                    onTouchTap={this.handleClose}
                  />
                  <FlatButton className="blue_btn"
                    label="Submit"
                    primary={true}
                    type='submit'
                  />
                </div>
              </div> */}
            </form>
          </div>
        </div>
      </Dialog>
    );
  }
}
const selector = formValueSelector('MasterDocumentTypesModalForm');
function mapStateToProps(state, ownProps) {
  // console.log('ownProps.documentTypeData: ', ownProps.documentTypeData);
  let initialValueData = null;
  if (ownProps.documentTypeId && state.masterDocumentTypes.getDocumentTypeById && state.masterDocumentTypes.getDocumentTypeById.data) {
    initialValueData = state.masterDocumentTypes.getDocumentTypeById.data;

    let masterDocumentTypeData = state.masterDocumentTypes.getDocumentTypeById.data;
   
    let masterDocumentTypesStaffUserRoles = (masterDocumentTypeData.masterDocumentTypesStaffUserRoles || []).map((obj) => obj.roleId);
    let masterDocumentTypesStaffPayers = (masterDocumentTypeData.masterDocumentTypesStaffPayers || []).map((obj) => obj.payerId);
    initialValueData = {
      ...initialValueData,
      userRoles: masterDocumentTypesStaffUserRoles,
      payers: masterDocumentTypesStaffPayers,
    };

  }
  return {
    userRoles: selector(state, 'userRoles'),
    payers: selector(state, 'payers'),
    fieldError: state.appConfig.fieldError,
    fieldErrorLoading: state.appConfig.fieldErrorLoading,
    initialValues: initialValueData,
    loading: state.masterDocumentTypesStaff.loading,
    userRoleList: state.masterDocumentTypesStaff.master_Data && state.masterDocumentTypesStaff.master_Data.masterRoles,
    insuranceCompaniesList: state.masterDocumentTypesStaff.master_Data && state.masterDocumentTypesStaff.master_Data.insuranceCompanies,
    masterDocumentTypeDetail: state.masterDocumentTypes.getDocumentTypeById,
    agencyName: state.login.organizationDetails && state.login.organizationDetails.businessName ? state.login.organizationDetails.businessName : '',
  };
}

MasterDocumentTypesModal = reduxForm({
  form: 'MasterDocumentTypesModalForm',
  validate,
  enableReinitialize: true,
})(MasterDocumentTypesModal);

export default connect(mapStateToProps, { checkFieldExistence, clearFieldErrorArray, saveDocumentType, getDocumentTypeById })(MasterDocumentTypesModal);



// WEBPACK FOOTER //
// ./src/modules/Masters/components/masterDocumentTypesStaff/components/master-document-types-modal.js